import type { FunctionComponent } from "react";

import Card from "~/components/Card/Card";
import CardValue from "~/components/Card/components/CardValue.tsx";
import type { EInvoiceSeller } from "~/modules/billing/api/eInvoice/eInvoiceTypes.ts";
import { joinDefined } from "../eInvoiceFormat.ts";
import EInvoiceAddressBlock from "./EInvoiceAddressBlock.tsx";
import EInvoiceSectionErrors from "./EInvoiceSectionErrors.tsx";

type Props = {
	seller: EInvoiceSeller | null;
	errors?: string[];
};

const EInvoiceSellerSection: FunctionComponent<Props> = ({ seller, errors }) => (
	<Card title="Verkäufer">
		<EInvoiceSectionErrors errors={errors} />
		{seller === null ? (
			<span className="text-sm text-gray-500">Kein Verkäuferprofil konfiguriert</span>
		) : (
			<div className="flex flex-col gap-3">
				<CardValue label="Name">{seller.name}</CardValue>
				{seller.tradingName !== null && <CardValue label="Handelsname">{seller.tradingName}</CardValue>}
				{seller.vatIdentifier !== null && <CardValue label="USt-IdNr.">{seller.vatIdentifier}</CardValue>}
				{seller.electronicAddress !== null && (
					<CardValue label="Elektronische Adresse">
						{seller.electronicAddress}
						{seller.electronicAddressScheme !== null && ` (${seller.electronicAddressScheme})`}
					</CardValue>
				)}
				{seller.address !== null && (
					<CardValue label="Adresse">
						<EInvoiceAddressBlock address={seller.address} />
					</CardValue>
				)}
				<CardValue label="Kontakt">
					{joinDefined([seller.contact.name, seller.contact.phone, seller.contact.email], " · ")}
				</CardValue>
				<CardValue label="Bankverbindung">
					{joinDefined([seller.bankAccount.iban, seller.bankAccount.bic, seller.bankAccount.name], " · ")}
				</CardValue>
			</div>
		)}
	</Card>
);

export default EInvoiceSellerSection;
